module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.646d0286.svg";